module.exports = __webpack_public_path__ + "img/20.5c29d0d1.jpg";